import { Pagination, Autoplay, EffectFade } from 'swiper';
import SliderBase from './slider-base';

const SLIDER_DELAY = 7000;

export default class SliderHero extends SliderBase {
    static initAll() {
        const swiperContainer = document.querySelector('.slider-hero-enabled.swiper');

        if (swiperContainer === null) return;

		const swiperSlides = swiperContainer.querySelectorAll('.swiper-slide');

		if (swiperSlides.length <= 1) return;

        const config = {
            modules: [Pagination, Autoplay, EffectFade],
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
			},
			slideVisibleClass: 'swiper-slide-visible',
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
            autoplay: {
                delay: SLIDER_DELAY,
                disableOnInteraction: false,
            },
        };

        new this(swiperContainer, config);
    }
}
